export default __webpack_public_path__ + "static/media/OCI300.2281c5af.jpg";